<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          招商赋能
          <span class="titleColor"></span> -面试列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 检索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="面试编号">
          <el-input v-model="listQuery.interviewNo" placeholder="面试编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="面试者编号">
          <el-input v-model="listQuery.workerNo" placeholder="面试者编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="面试者">
          <el-input v-model="listQuery.workerName" placeholder="面试者" clearable></el-input>
        </el-form-item>
        <el-form-item label="面试官">
          <el-input v-model="listQuery.interviewerName" placeholder="面试官" clearable></el-input>
        </el-form-item>
        <el-form-item label="关联线索编号">
          <el-input v-model="listQuery.relationClueNo" placeholder="关联线索编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="关联任务编号">
          <el-input v-model="listQuery.relationTaskNo" placeholder="关联任务编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="面试时间">
          <el-date-picker v-model="listQuery.interviewTime" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="面试状态">
          <el-select v-model="listQuery.status" style="width:150px" clearable placeholder="面试状态" multiple>
            <el-option v-for="(item, index) in statusList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="面试结果">
          <el-select v-model="listQuery.subStatus" style="width:150px" clearable placeholder="面试子状态">
            <el-option v-for="(item, index) in subStatusList" :key="index" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
        </el-form-item>

      </el-form>

      <!-- 表单 -->
      <el-table :data="listData" border class="table">
        <el-table-column prop="id" width="100" label="id" fixed></el-table-column>
        <el-table-column prop="interviewNo" label="面试编号"></el-table-column>
        <el-table-column prop="interviewName" label="面试名称"></el-table-column>
        <el-table-column prop="workerNo" label="面试者编号"></el-table-column>
        <el-table-column prop="workerName" label="面试者"></el-table-column>
        <el-table-column prop="interviewerName" label="面试官"></el-table-column>
        <el-table-column prop="stationName" label="服务站"></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <el-table-column prop="interviewTitle" label="面试标题"></el-table-column>
        <el-table-column prop="interviewContent" label="面试内容"></el-table-column>
        <el-table-column prop="interviewTime" label="面试时间" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="relationClueId" label="关联线索id"></el-table-column>
        <el-table-column prop="relationTaskId" label="关联任务id"></el-table-column>
        <el-table-column prop="status" label="面试状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status != ''">{{ statusList[scope.row.status - 1].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="面试结果">
          <template slot-scope="scope">
            <span v-if="scope.row.subStatus != ''">{{ subStatusList[scope.row.subStatus - 1].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="取消面试类型">
          <template slot-scope="scope">
            <span v-if="scope.row.cancelReasonType != ''">{{ cancelTypeList[scope.row.cancelReasonType - 1].label
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cancelReason" label="取消原因"></el-table-column>



        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
        <!-- <el-table-column prop="updateTime" label="修改时间" :formatter="dateFormat"></el-table-column> -->
        <el-table-column prop label="操作" fixed="right" width="200">
          <template slot-scope="scope"><!--  -->
            <el-button type="text" icon="el-icon-check" v-if="scope.row.status == 2"
              @click="finishInterview(scope.row)">完成面试</el-button>
            <el-button type="text" icon="el-icon-delete" v-if="scope.row.status == 1 || scope.row.status == 2"
              @click="cancelInterview(scope.row)" class="red">取消面试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
    </div>
    <!-- 完成面试 -->
    <complateInterview ref="complateInterviewRef" />

    <!--取消面试-->
    <cancelInterview ref="cancelInterviewRef" />

  </div>
</template>
<script>
import moment from "moment";
import workercrmapi from "@/script/api/workercrmapi";
import wmsApi from "@/script/api/wmsApi";
import taskApi from "@/script/api/taskApi";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import service from "@/script/api/service";
import cancelInterview from "@/components/task/cancelInterview.vue";
import complateInterview from "@/components/task/complateInterview.vue";

export default {
  components: { Pagination, cancelInterview, complateInterview },
  data() {
    return {
      statusList: [
        {
          value: 1,
          label: '待确认'
        },
        {
          value: 2,
          label: '待面试'
        },
        {
          value: 3,
          label: '已面试'
        },
        {
          value: 4,
          label: '面试取消'
        },
      ],
      subStatusList: [
        {
          value: 1,
          label: '面试通过'
        },
        {
          value: 2,
          label: '需再次面试'
        },
        {
          value: 3,
          label: '面试淘汰'
        },

      ],
      cancelTypeList: [
        {
          value: 1,
          label: '面试者原因'
        },
        {
          value: 2,
          label: '面试官原因'
        },
        {
          value: 3,
          label: '其他原因'
        },

      ],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      listData: [],
      listQuery: {
        interviewNo: '',
        workerNo: '',
        workerName: "",
        interviewerName: "",
        relationClueNo: "",
        relationTaskNo: "",
        status: [],
        subStatus: "",
        interviewTime: [],
        interviewTimeStart: '',
        interviewTimeEnd: '',
      },

    };
  },


  mounted() {
    if (this.$route.query.wokrerNo) {
      this.listQuery.workerNo = this.$route.query.wokrerNo;
    }
    // 监听localStorage变化
    window.addEventListener('storage', this.handleStorageChange);

    // 检查是否有待处理的workerNo
    const storedWorkerNo = localStorage.getItem('interviewListWorkerNo');
    if (storedWorkerNo) {
      this.listQuery.workerNo = storedWorkerNo;
      localStorage.removeItem('interviewListWorkerNo');
    }
    this.querySearch();
  },

  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('storage', this.handleStorageChange);
  },

  methods: {
    // 监听localStorage变化
    handleStorageChange(event) {
      if (event.key === 'interviewListWorkerNo' && event.newValue) {
        this.listQuery.workerNo = event.newValue;
        this.querySearch();
      }
    },
    //查询
    querySearch() {
      let params = this.listQuery;
      params.page = this.currentPage;
      params.size = this.pageSize;
      if (params.interviewTime) {
        params.interviewTimeStart = params.interviewTime[0];
        params.interviewTimeEnd = params.interviewTime[1];
      }
      delete params.interviewTime;
      taskApi
        .$axiosListInterview(params)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },

    cancelInterview(row) {
      this.$refs.cancelInterviewRef.cancelInterview(row);

      // this.interviewId=row.id;
      // this.cancelVisible=true;
      // this.cancelForm= {
      //   cancelType: '',
      //   cancelReason: '',
      // };
    },
    finishInterview(row) {
      this.$refs.complateInterviewRef.finishInterview(row);

      // this.interviewId = row.id;
      // this.finishVisible = true;
      // this.finishForm = {
      //   subStatus: "",
      // };
    },

    //取消重置
    cancelAddTaskForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.addVisible = false;
    },

    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined || date == "") {
        return "";
      }

      // 2025-07-15 15:20 - 18:20
      if (date.includes(' - ')) {
        return date;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    }
  }
};
</script>
<style scoped>
.el-form {
  padding: 0 60px 0 20px !important;
}

.el-select.el-select--small,
.el-input--small {
  width: 100%;
}
</style>
